/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { PortalCard } from "@advapacs/common";
import React, { FC } from "react";
import LinkIcon from "@src/assets/icons/link.svg";
import ResultIcon from "@src/assets/icons/result.svg";
import UnionIcon from "@src/assets/icons/union.svg";

const DashboardContainer: FC = () => {
  return (
    <div className="row">
      <div className="col-md-12 text-center big-title m-t-md ">
        <h1 className="font-weight font-large-middle ">
          How to access the Patient Portal
        </h1>
      </div>

      <div className="col-md-12 ">
        <div className="row">
          <div className="col-lg-4 col-sm-12 col-xs-12 dashboard-card">
            <PortalCard wrapperClass="study-card border-light landing m-h-card-banner box-shadow-none bg-white">
              <div className="box-content">
                <div className="icon d-flex m-b-md">
                  <img src={UnionIcon} alt="Union Icon" />
                </div>
                <div className="">
                  <div className="text-banner font-weight m-b-xxs">STEP 1</div>
                  <h3 className="font-weight m-b-sm">Receive SMS or email</h3>
                  <p className="m-b-none">
                    After your exam, you will receive an SMS or email containing
                    a link to access the Patient Portal.
                  </p>
                  <p>
                    <i>
                      Note: If you don't receive the SMS or email, please
                      contact your healthcare provider for assistance.
                    </i>
                  </p>
                </div>
              </div>
            </PortalCard>
          </div>
          <div className="col-lg-4 col-sm-12 col-xs-12 dashboard-card">
            <PortalCard wrapperClass="study-card border-light landing m-h-card-banner box-shadow-none bg-white">
              <div className="box-content">
                <div className="icon d-flex m-b-md">
                  <img src={LinkIcon} alt="Link Icon" />
                </div>
                <div>
                  <div className="text-banner font-weight m-b-xxs">STEP 2</div>
                  <h3 className="font-weight m-b-sm">Click the link</h3>
                  <p>
                    Click on the link to be redirected to the Patient Portal,
                    where you will follow the necessary authentication steps.
                  </p>
                </div>
              </div>
            </PortalCard>
          </div>
          <div className="col-lg-4 col-sm-12 col-xs-12 dashboard-card">
            <PortalCard wrapperClass="study-card border-light landing m-h-card-banner box-shadow-none bg-white">
              <div className="box-content">
                <div className="icon d-flex m-b-md">
                  <img src={ResultIcon} alt="Result Icon" />
                </div>
                <div>
                  <div className="text-banner font-weight m-b-xxs">STEP 3</div>
                  <h3 className="font-weight m-b-sm">
                    View Results and Images
                  </h3>
                  <p>
                    Once successfully authenticated, you will be able to view
                    your results and images within the Patient Portal.
                  </p>
                </div>
              </div>
            </PortalCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContainer;
